import React from 'react';
import BackIcon from '../../../components/Icons/BackIcon';
import './DiscrepancyHeader.css';
import DocumentIcon from '../../../components/Icons/DocumentIcon';
import CheckIcon from '../../../components/Icons/CheckIcon';
import AlertIcon from '../../../components/Icons/AlertIcon';
import CountDownIcon from '../../../components/Icons/CountDownIcon';

export const DiscrepancyHeader = ({inventoryName, total, issues, resolved, remaining, onConfirm, onReject, onBack, confirmDisabled, inReview, isHqUser}) =>
{
  const progressPct = total > 0 ? Math.round((resolved / total) * 100) : 0;

  return (
    <div className="disc-header">
      {/* Top row: back + title + actions */}
      <div className="disc-header-top">
        <button className="disc-back-btn" onClick={onBack}>
          <BackIcon/>
        </button>
        <div className="disc-title-block">
          <div className="disc-subtitle">{inventoryName || 'Inventory'}</div>
          <h1 className="disc-title">Review and Manage Discrepancies</h1>
        </div>

        {/* Stats pills */}
      <div className="disc-stats-bar">
        <div className="disc-stat-pill">
          <DocumentIcon width={25} height={25} color='#2B7FFF'/>
          Total <span className="disc-stat-value">{total}</span>
        </div>
        <div className="disc-stat-pill">
          <AlertIcon width={25} height={25} color='#D4183D'/>
          Issues <span className="disc-stat-value">{issues}</span>
        </div>
        <div className="disc-stat-pill">
          <CheckIcon width={25} height={25} color='#10B981'/>
          Resolved <span className="disc-stat-value">{resolved}</span>
        </div>
        <div className="disc-stat-pill">
          <CountDownIcon width={25} height={25} color='#F97316'/>
          Remaining <span className="disc-stat-value">{remaining}</span>
        </div>
      </div>

        {/* Action buttons */}
        {!inReview && (
          <button
            className="disc-confirm-btn"
            onClick={onConfirm}
            disabled={confirmDisabled}
            title={confirmDisabled ? 'Resolve all pending items before sending for review' : undefined}
          >
            Send To Review
          </button>
        )}

        {inReview && isHqUser && (
          <div className="disc-hq-actions">
            <button className="disc-reject-btn" onClick={onReject}>
              Reject
            </button>
            <button className="disc-confirm-btn" onClick={onConfirm}>
              Confirm
            </button>
          </div>
        )}
      </div>

      {/* Progress bar */}
      <div className="disc-progress-track">
        <div className="disc-progress-fill" style={{ width: `${progressPct}%` }}/>
      </div>
    </div>
  );
};
